export default __webpack_public_path__ + "static/media/csvUpdate.73ce877b.csv";